import { Component } from '@angular/core';
import { MenuController } from 'ionic-angular';
import {
  IonicPage,
  ViewController,
  NavController,
  NavParams
} from 'ionic-angular';
import { HomePage } from '../home/home';
import { BqApiProvider } from '../../providers/bq-api/bq-api';
import { URLSearchParams } from '@angular/http';



@IonicPage()
@Component({
  selector: 'page-landing',
  templateUrl: 'landing.html'
})
export class LandingPage {
  public npsToken: string;
  public prevEverest: string;
  public show: boolean;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public viewCtrl: ViewController,
    public menuCtrl: MenuController,
    private bqapi: BqApiProvider
  ) {}

  ionViewDidLoad() {
    this.loadCampaignInfo();
    this.show = true;
  }

  nextStep( loadPrev: boolean ) {
    this.show = false;
    if( loadPrev ){
      let uuid = window.localStorage.getItem('BQ360Everest::UUID');
      let data = JSON.parse(window.localStorage.getItem('BQ360Everest::Data::' + uuid));
      let steps = JSON.parse(window.localStorage.getItem('BQ360Everest::Steps::' + uuid));
      let comments = JSON.parse(window.localStorage.getItem('BQ360Everest::Comments::' + uuid));

      if( !steps )
        steps = [];

      if( !comments )
        comments = [];

      console.log('Loading previous answers UUID: ' + uuid + ' - Data: %o - Steps: %o', data, steps );
      this.bqapi.resume( uuid, data, steps, comments );
      this.navCtrl.push(HomePage);
    }else{
      window.localStorage.clear();
      this.navCtrl.push(HomePage);
    }
  }

  loadCampaignInfo() {
    let params = new URLSearchParams(window.location.search);
    let token = params.get('?everest');

    this.bqapi.getCampaign(token)
      .then((campaign) => {
        let prevEverest = window.localStorage.getItem('BQ360Everest::UUID');

        if( prevEverest ){
          this.prevEverest = prevEverest;
        }
        console.dir(campaign);
      })
  }

}



// WEBPACK FOOTER //
// ./src/pages/landing/landing.ts